import { render } from "./BlockAction.component.vue?vue&type=template&id=5d164d60"
import script from "./BlockAction.component.vue?vue&type=script&lang=js"
export * from "./BlockAction.component.vue?vue&type=script&lang=js"

import "./BlockAction.component.vue?vue&type=style&index=0&id=5d164d60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__